// import React, { useState, useEffect } from "react";
// import { UploadCloud, X } from "lucide-react";
// import { useVideo } from "../context/VideoContext";
// import toast from "react-hot-toast";

// const VideoModal = ({ close, editData }) => {
//   const { addVideo, updateVideo } = useVideo();

//   const [form, setForm] = useState({
//     id: null,
//     sectionTitle: "",
//     link: "",
//     title: "",
//     description: "",
//     thumbnail: "",
//     createdAt: "",
//   });

//   useEffect(() => {
//     if (editData) {
//       setForm(editData);
//     }
//   }, [editData]);

//   const handleThumbnailUpload = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     const reader = new FileReader();
//     reader.onloadend = () => {
//       setForm((prev) => ({
//         ...prev,
//         thumbnail: reader.result,
//       }));
//     };
//     reader.readAsDataURL(file);
//   };

//   const handleSave = () => {
//   if (!form.title) return;

//   if (editData) {
//     updateVideo(form);
//     toast.success("Video updated ✅");
//   } else {
//     addVideo({
//       ...form,
//       id: Date.now(),
//       createdAt: new Date().toISOString(),
//     });
//     toast.success("Video added ✅");
//   }

//   close();
// };

//   return (
//   <div className="fixed inset-0 bg-black/40 flex justify-center items-start z-50 p-3 md:p-4 overflow-y-auto">

//     <div className="bg-white w-full max-w-3xl rounded-xl relative max-h-[90vh] overflow-y-auto">

//       {/* Close */}
//       <button
//         onClick={close}
//         className="absolute top-4 right-4 text-gray-500 hover:text-red-500 z-10"
//       >
//         <X size={20} />
//       </button>

//       <div className="p-4 md:p-6">

//         <h2 className="font-serif mb-6 text-base md:text-lg">
//           {editData ? "Edit Video" : "Add Video"}
//         </h2>

//         <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">

//           {/* LEFT */}
//           <div className="space-y-4">
//             <div>
//               <label className="text-sm font-medium">Section Title</label>
//               <input
//                 className="w-full border p-3 rounded-md mt-1"
//                 value={form.sectionTitle}
//                 onChange={(e) =>
//                   setForm({ ...form, sectionTitle: e.target.value })
//                 }
//               />
//             </div>

//             <div>
//               <label className="text-sm font-medium">Video Title</label>
//               <input
//                 className="w-full border p-3 rounded-md mt-1"
//                 value={form.title}
//                 onChange={(e) =>
//                   setForm({ ...form, title: e.target.value })
//                 }
//               />
//             </div>

//             <div>
//               <label className="text-sm font-medium">Video Description</label>
//               <textarea
//                 className="w-full border p-3 rounded-md mt-1 h-[100px]"
//                 value={form.description}
//                 onChange={(e) =>
//                   setForm({ ...form, description: e.target.value })
//                 }
//               />
//             </div>
//           </div>

//           {/* RIGHT */}
//           <div className="space-y-4">
//             <div>
//               <label className="text-sm font-medium">Video Link</label>
//               <input
//                 className="border p-3 rounded-md w-full mt-1"
//                 value={form.link}
//                 onChange={(e) =>
//                   setForm({ ...form, link: e.target.value })
//                 }
//               />
//             </div>

//             <label className="border-2 border-dashed h-[130px] md:h-[140px] rounded-md flex flex-col items-center justify-center text-gray-400 cursor-pointer relative">
//               <UploadCloud className="text-[#6f8f2f] mb-1" size={26} />
//               Upload Thumbnail

//               <input
//                 type="file"
//                 accept="image/*"
//                 onChange={handleThumbnailUpload}
//                 className="absolute inset-0 opacity-0 cursor-pointer"
//               />
//             </label>

//             {form.thumbnail && (
//               <img
//                 src={form.thumbnail}
//                 alt={form.title}
//                 className="w-full h-[130px] md:h-[140px] object-cover rounded-md"
//               />
//             )}
//           </div>
//         </div>

//         <div className="flex justify-end mt-6">
//           <button
//             onClick={handleSave}
//             className="bg-[#45A301] text-white px-5 py-2 rounded-md text-sm"
//           >
//             {editData ? "Update Video" : "Save Video"}
//           </button>
//         </div>

//       </div>
//     </div>
//   </div>
// );
// };

// export default VideoModal;

// import { useState, useEffect } from "react";
// import { FiX, FiUploadCloud } from "react-icons/fi";
// import { toast } from "react-toastify";
// import SummaryApi from "../common/SummaryApi";
// import api from "../common/apiClient";

// const VideoModal = ({ close, editData, refresh }) => {
//   const [loading, setLoading] = useState(false);
//   const [form, setForm] = useState({
//     title: "",
//     videoUrl: "",
//     description: "",
//     section: "gallery",
//     type: "VIDEO",
//     thumbnail: null
//   });
//   const [preview, setPreview] = useState(null);

//   useEffect(() => {
//     if (editData) {
//       setForm({ ...editData });
//       setPreview(editData.thumbnail?.url);
//     }
//   }, [editData]);

//   const handleSave = async () => {
//     if (!form.title || !form.videoUrl) return toast.warning("Title and Video URL are required");
    
//     setLoading(true);
//     const formData = new FormData();
//     formData.append("title", form.title);
//     formData.append("videoUrl", form.videoUrl);
//     formData.append("description", form.description);
//     formData.append("type", "VIDEO");
//     formData.append("section", form.section);
//     if (form.thumbnail instanceof File) formData.append("thumbnail", form.thumbnail);

//     try {
//       const apiConfig = editData 
//         ? { url: SummaryApi.updateOneGallery.url(editData._id), method: SummaryApi.updateOneGallery.method }
//         : { url: SummaryApi.createGallery.url, method: SummaryApi.createGallery.method };

//       await api({ ...apiConfig, data: formData, headers: { "Content-Type": "multipart/form-data" } });
//       toast.success(editData ? "Video Updated" : "Video Created");
//       refresh();
//       close();
//     } catch (err) {
//       toast.error("Process failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[10000] flex items-center justify-center p-4">
//       <div className="bg-white w-full max-w-2xl rounded-xl shadow-2xl overflow-hidden">
//         <div className="flex justify-between items-center px-6 py-4 border-b bg-gray-50">
//           <h3 className="font-bold">{editData ? "Edit Video" : "Add Video"}</h3>
//           <button onClick={close}><FiX size={20} /></button>
//         </div>
//         <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-6 max-h-[70vh] overflow-y-auto">
//           <div className="space-y-4">
//             <div><label className="text-xs font-bold text-gray-500 uppercase">Title</label>
//             <input className="w-full border p-2 rounded mt-1" value={form.title} onChange={e => setForm({...form, title: e.target.value})} /></div>
//             <div><label className="text-xs font-bold text-gray-500 uppercase">Video URL</label>
//             <input className="w-full border p-2 rounded mt-1" placeholder="YouTube link" value={form.videoUrl} onChange={e => setForm({...form, videoUrl: e.target.value})} /></div>
//             <div><label className="text-xs font-bold text-gray-500 uppercase">Description</label>
//             <textarea className="w-full border p-2 rounded mt-1 h-24" value={form.description} onChange={e => setForm({...form, description: e.target.value})} /></div>
//           </div>
//           <div className="space-y-4">
//             <label className="border-2 border-dashed h-40 rounded-lg flex flex-col items-center justify-center cursor-pointer hover:bg-gray-50">
//               {preview ? <img src={preview} className="h-full w-full object-cover rounded-lg" alt="prev" /> : 
//               <><FiUploadCloud size={30} className="text-[#45A301]" /> <span className="text-sm mt-2">Upload Thumbnail</span></>}
//               <input type="file" className="hidden" onChange={e => {
//                 const file = e.target.files[0];
//                 setForm({...form, thumbnail: file});
//                 setPreview(URL.createObjectURL(file));
//               }} />
//             </label>
//           </div>
//         </div>
//         <div className="p-6 border-t bg-gray-50 flex justify-end gap-3">
//           <button onClick={close} className="px-4 py-2 border rounded text-sm">Cancel</button>
//           <button onClick={handleSave} disabled={loading} className="px-6 py-2 bg-[#45A301] text-white rounded text-sm disabled:opacity-50">
//             {loading ? "Saving..." : "Save Video"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };
// export default VideoModal;

import { useState, useEffect } from "react";
import { FiX, FiUploadCloud } from "react-icons/fi";
import { toast } from "react-toastify";
import SummaryApi from "../common/SummaryApi";
import api from "../common/apiClient";

const VideoModal = ({ close, editData, refresh }) => {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    title: "",
    videoUrl: "",
    description: "",
    tag: "", // Added tag field
    section: "gallery",
    type: "VIDEO",
    thumbnail: null
  });
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    if (editData) {
      setForm({ 
        ...editData,
        tag: editData.tag || "" // Ensure tag is mapped from editData
      });
      setPreview(editData.thumbnail?.url);
    }
  }, [editData]);

  const handleSave = async () => {
    if (!form.title || !form.videoUrl) return toast.warning("Title and Video URL are required");
    
    setLoading(true);
    const formData = new FormData();
    formData.append("title", form.title);
    formData.append("videoUrl", form.videoUrl);
    formData.append("description", form.description);
    formData.append("tag", form.tag || ""); // Append tag to FormData
    formData.append("type", "VIDEO");
    formData.append("section", form.section);
    
    if (form.thumbnail instanceof File) {
      formData.append("thumbnail", form.thumbnail);
    }

    try {
      const apiConfig = editData 
        ? { url: SummaryApi.updateOneGallery.url(editData._id), method: SummaryApi.updateOneGallery.method }
        : { url: SummaryApi.createGallery.url, method: SummaryApi.createGallery.method };

      await api({ 
        ...apiConfig, 
        data: formData, 
        headers: { "Content-Type": "multipart/form-data" } 
      });

      toast.success(editData ? "Video Updated Successfully" : "Video Created Successfully");
      refresh();
      close();
    } catch (err) {
      console.error(err);
      toast.error("Process failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[10000] flex items-center justify-center p-4">
      <div className="bg-white w-full max-w-2xl rounded-xl shadow-2xl overflow-hidden">
        {/* Header */}
        <div className="flex justify-between items-center px-6 py-4 border-b bg-gray-50">
          <h3 className="font-bold text-gray-800">{editData ? "Edit Video" : "Add Video"}</h3>
          <button onClick={close} className="text-gray-500 hover:text-red-500 transition-colors">
            <FiX size={20} />
          </button>
        </div>

        {/* Body */}
        <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-6 max-h-[75vh] overflow-y-auto">
          {/* Left Column: Text Inputs */}
          <div className="space-y-4">
            <div>
              <label className="text-xs font-bold text-gray-500 uppercase">Title</label>
              <input 
                className="w-full border p-2.5 rounded-lg mt-1 outline-none focus:ring-2 ring-gray-200" 
                placeholder="Enter video title"
                value={form.title} 
                onChange={e => setForm({...form, title: e.target.value})} 
              />
            </div>

            <div>
              <label className="text-xs font-bold text-gray-500 uppercase">Tag (e.g. Cardamom, Plantation)</label>
              <input 
                className="w-full border p-2.5 rounded-lg mt-1 outline-none focus:ring-2 ring-gray-200" 
                placeholder="Enter category tag"
                value={form.tag} 
                onChange={e => setForm({...form, tag: e.target.value})} 
              />
            </div>

            <div>
              <label className="text-xs font-bold text-gray-500 uppercase">Video URL</label>
              <input 
                className="w-full border p-2.5 rounded-lg mt-1 outline-none focus:ring-2 ring-gray-200" 
                placeholder="Paste YouTube/Vimeo link" 
                value={form.videoUrl} 
                onChange={e => setForm({...form, videoUrl: e.target.value})} 
              />
            </div>

            <div>
              <label className="text-xs font-bold text-gray-500 uppercase">Description</label>
              <textarea 
                className="w-full border p-2.5 rounded-lg mt-1 h-24 outline-none focus:ring-2 ring-gray-200 resize-none" 
                placeholder="Enter short description"
                value={form.description} 
                onChange={e => setForm({...form, description: e.target.value})} 
              />
            </div>
          </div>

          {/* Right Column: Thumbnail Upload */}
          <div className="space-y-4">
            <label className="text-xs font-bold text-gray-500 uppercase">Thumbnail Image</label>
            <label className="border-2 border-dashed h-56 rounded-xl flex flex-col items-center justify-center cursor-pointer hover:bg-gray-50 transition-colors overflow-hidden relative">
              {preview ? (
                <img src={preview} className="h-full w-full object-cover" alt="thumbnail preview" />
              ) : (
                <div className="text-center">
                  <FiUploadCloud size={40} className="mx-auto text-[#45A301]" />
                  <p className="mt-2 text-sm text-gray-500 font-medium">Upload Thumbnail</p>
                  <p className="text-[10px] text-gray-400 mt-1">PNG, JPG or WebP (16:9 recommended)</p>
                </div>
              )}
              <input 
                type="file" 
                className="hidden" 
                accept="image/*"
                onChange={e => {
                  const file = e.target.files[0];
                  if (file) {
                    setForm({...form, thumbnail: file});
                    setPreview(URL.createObjectURL(file));
                  }
                }} 
              />
            </label>
            {preview && (
              <button 
                onClick={() => { setPreview(null); setForm({...form, thumbnail: null}); }}
                className="text-xs text-red-500 hover:underline w-full text-center"
              >
                Remove and select another
              </button>
            )}
          </div>
        </div>

        {/* Footer */}
        <div className="p-6 border-t bg-gray-50 flex justify-end gap-3">
          <button 
            onClick={close} 
            className="px-4 py-2 border rounded-md text-sm font-medium hover:bg-white transition-all"
          >
            Cancel
          </button>
          <button 
            onClick={handleSave} 
            disabled={loading} 
            className="px-6 py-2 bg-[#45A301] text-white rounded-md text-sm font-medium disabled:opacity-50 hover:bg-[#3a8a01] transition-all flex items-center gap-2"
          >
            {loading ? "Saving..." : editData ? "Update Video" : "Save Video"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default VideoModal;